import { render, staticRenderFns } from "./CreateReturnPortal.vue?vue&type=template&id=46f0ca5f&"
import script from "./CreateReturnPortal.vue?vue&type=script&lang=js&"
export * from "./CreateReturnPortal.vue?vue&type=script&lang=js&"
import style0 from "./CreateReturnPortal.vue?vue&type=style&index=0&id=46f0ca5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports